import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-086be167")

_pushScopeId("data-v-086be167")
const _hoisted_1 = { class: "site container" }
const _hoisted_2 = { class: "site-box-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "news-wrapper site-wrapper"
}
const _hoisted_4 = { class: "site-box" }
const _hoisted_5 = { class: "address" }
const _hoisted_6 = { class: "desc" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "tel" }
const _hoisted_9 = { class: "price flexRow" }
const _hoisted_10 = { class: "btns flexRow" }
const _hoisted_11 = { class: "news-wrapper site-content-wrapper" }
const _hoisted_12 = { class: "flexRow site-content" }
const _hoisted_13 = {
  id: "siteLeftmenu",
  class: "site-left"
}
const _hoisted_14 = { class: "site-right" }
const _hoisted_15 = {
  class: "site-space",
  ref: "base"
}
const _hoisted_16 = { class: "site-space-item" }
const _hoisted_17 = /*#__PURE__*/_createVNode("div", { class: "i-title flexRow" }, [
  /*#__PURE__*/_createVNode("h3", { id: "d1" }, "基本概况"),
  /*#__PURE__*/_createVNode("div", { class: "i-title-border" })
], -1)
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "site-space-item" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "i-title flexRow" }, [
  /*#__PURE__*/_createVNode("h3", { id: "d1" }, " 关注领域"),
  /*#__PURE__*/_createVNode("div", { class: "i-title-border" })
], -1)
const _hoisted_21 = { class: "content" }
const _hoisted_22 = { class: "site-space-item" }
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "i-title flexRow" }, [
  /*#__PURE__*/_createVNode("h3", { id: "d1" }, "孵化成果"),
  /*#__PURE__*/_createVNode("div", { class: "i-title-border" })
], -1)
const _hoisted_24 = { class: "site-space-item" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "i-title flexRow" }, [
  /*#__PURE__*/_createVNode("h3", { id: "d1" }, "配套服务"),
  /*#__PURE__*/_createVNode("div", { class: "i-title-border" })
], -1)
const _hoisted_26 = { class: "content" }
const _hoisted_27 = {
  ref: "banner",
  class: "banner-swiper-base",
  id: "d2"
}
const _hoisted_28 = {
  class: "site-news",
  ref: "newsList"
}
const _hoisted_29 = {
  class: "hot-bottom-news",
  id: "d3"
}
const _hoisted_30 = {
  href: "javascript:void(0)",
  class: "flexRow"
}
const _hoisted_31 = { class: "time" }
const _hoisted_32 = { class: "text overflowOne" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", null, "活动", -1)
const _hoisted_34 = {
  key: 0,
  href: "javascript:void(0)",
  class: "flexRow"
}
const _hoisted_35 = { class: "time" }
const _hoisted_36 = { class: "text overflowOne" }
const _hoisted_37 = /*#__PURE__*/_createVNode("span", null, "热门", -1)
const _hoisted_38 = {
  class: "site-tel",
  ref: "tel",
  id: "d4"
}
const _hoisted_39 = { class: "name" }
const _hoisted_40 = { class: "address" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      class: "site-banner",
      style: {backgroundImage:`url(${_ctx.news.indexImage})`}
    }, null, 4),
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        (_ctx.news)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("h3", null, _toDisplayString(_ctx.news.siteName), 1),
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.news.address), 1),
                _createVNode("div", _hoisted_6, [
                  _createVNode("div", _hoisted_7, "创业关爱官：" + _toDisplayString(_ctx.news.contacts), 1),
                  _createVNode("div", _hoisted_8, "联系电话：" + _toDisplayString(_ctx.news.contactNumber), 1),
                  _createVNode("div", _hoisted_9, [
                    _createVNode("span", null, _toDisplayString(_ctx.news.monthRent), 1),
                    _createVNode("i", null, _toDisplayString(_ctx.news.feeTypeStr || '元起/m²/月'), 1)
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("a", {
                      href: "javascript:;",
                      class: "i-button",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDialog('order')))
                    }, "预约参观"),
                    _createVNode("a", {
                      href: "javascript:;",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDialog('apply'))),
                      class: "i-button"
                    }, "申请入驻")
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_11, [
        _createVNode("div", _hoisted_12, [
          _createVNode("div", _hoisted_13, [
            _createVNode("div", {
              class: ["site-left-wrapper", [_ctx.isFixed ? 'isFixed' : '']]
            }, [
              _createVNode("ul", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.navList, (item, index) => {
                  return (_openBlock(), _createBlock("li", { key: index }, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.jump(index)),
                      class: _ctx.active == index ? 'active' : 'default'
                    }, _toDisplayString(item), 11, ["onClick"])
                  ]))
                }), 128))
              ])
            ], 2)
          ]),
          _createVNode("div", _hoisted_14, [
            _createVNode("div", _hoisted_15, [
              _createVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode("div", _hoisted_18, [
                  _createVNode("div", {
                    innerHTML: _ctx.news.introduction
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", {
                    innerHTML: _ctx.news.focusArea
                  }, null, 8, ["innerHTML"])
                ])
              ]),
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", {
                  class: "content",
                  innerHTML: _ctx.news.incubationResults
                }, null, 8, ["innerHTML"])
              ]),
              _createVNode("div", _hoisted_24, [
                _hoisted_25,
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", {
                    innerHTML: _ctx.news.supportServices
                  }, null, 8, ["innerHTML"])
                ])
              ])
            ], 512),
            _createVNode("div", _hoisted_27, [
              _createVNode(_component_el_carousel, {
                height: "540px",
                style: {"width":"828px"}
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.news.images, (item, index) => {
                    return (_openBlock(), _createBlock(_component_el_carousel_item, { key: index }, {
                      default: _withId(() => [
                        _createVNode("img", {
                          class: "banner",
                          src: item,
                          style: {"width":"100%","height":"100%","object-fit":"contain"}
                        }, null, 8, ["src"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              })
            ], 512),
            _createVNode("div", _hoisted_28, [
              _createVNode("div", _hoisted_29, [
                _createVNode("ul", null, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.activeList, (item) => {
                    return (_openBlock(), _createBlock("li", {
                      key: item.id,
                      onClick: ($event: any) => (_ctx.next(item.type, item.id))
                    }, [
                      _createVNode("a", _hoisted_30, [
                        _createVNode("div", _hoisted_31, _toDisplayString(item.startDateStr), 1),
                        _createVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ])
                      ])
                    ], 8, ["onClick"]))
                  }), 128)),
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.hotList, (item) => {
                    return (_openBlock(), _createBlock("li", {
                      key: item.id,
                      onClick: ($event: any) => (_ctx.next(item.type, item.id))
                    }, [
                      (item.type == 'type_02')
                        ? (_openBlock(), _createBlock("a", _hoisted_34, [
                            _createVNode("div", _hoisted_35, _toDisplayString(item.publishDateStr), 1),
                            _createVNode("div", _hoisted_36, [
                              _hoisted_37,
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ], 8, ["onClick"]))
                  }), 128))
                ])
              ])
            ], 512),
            _createVNode("div", _hoisted_38, [
              _createVNode("a", {
                target: "_blank",
                href: _ctx.news.addressLink
              }, [
                _createVNode("img", {
                  src: _ctx.news.addressImage
                }, null, 8, ["src"])
              ], 8, ["href"]),
              _createVNode("p", _hoisted_39, _toDisplayString(_ctx.news.siteName), 1),
              _createVNode("p", _hoisted_40, _toDisplayString(_ctx.news.siteAddress), 1)
            ], 512)
          ])
        ])
      ])
    ])
  ], 64))
})